import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ExistsAuditProtocolPage} from "../exists-audit-protocol/exists-audit-protocol";
import {ModalNavPage} from "../modal-nav/modal-nav";
import "rxjs/add/observable/forkJoin";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Subscription} from "rxjs/Subscription";
import {AuditService} from "../../store/audit/audit.service";
import {ContactEntity} from "../../store/contact/contact.entity";
import {ContactService} from "../../store/contact/contact.service";

/**
 * Generated class for the ExistsAuditCustomerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-exists-audit-customer',
  templateUrl: 'exists-audit-customer.html',
})
export class ExistsAuditCustomerPage implements OnInit, OnDestroy{

  public query: string = '';
  public searchTerm: string = '';
  public searchStrict: boolean = false;
  public queryProperty: string = 'company';
  public customers: Array<ContactEntity> = [];

  private _pruefungSubscription: Subscription;

  constructor(private modalNav: ModalNavPage,
              public navCtrl: NavController,
              public navParams: NavParams,
              private auditService: AuditService,
              private dataProvider: DataProvider,
              private contactService: ContactService) {
  }

  ngOnInit(){
    this._pruefungSubscription = this.auditService.getAllCustomerIdsOfAllAudits()
      .flatMap((ids: Array<string>) => this.contactService.getByIds(ids))
      .subscribe((contacts: Array<ContactEntity>) => {
        this.customers = contacts;
      });
  }

  ngOnDestroy(){
    this._pruefungSubscription.unsubscribe();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ExistsAuditCustomerPage');
  }


  public print(pruefung):void {
    console.dir(pruefung);
  }

  public showExistedAuditsForCustomer(id: string): void {

    this.navCtrl.push(ExistsAuditProtocolPage, {customerId: id});

  }

  public close(): void {
      this.modalNav.dismissModal();
  }

  public onInput(event: any): void {
    let searchTerm = event.target.value;
    if(searchTerm && searchTerm.length > 2){
      switch (true) {
        case (searchTerm.toLowerCase().startsWith('ort:') && searchTerm.length > 4):
          this.queryProperty = 'city';
          this.searchTerm = searchTerm.replace('ort:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('vorname:') && searchTerm.length > 8):
          this.queryProperty = 'firstName';
          this.searchTerm = searchTerm.replace('vorname:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('name:') && searchTerm.length > 5):
          this.queryProperty = 'lastName';
          this.searchTerm = searchTerm.replace('name:', '');
          this.searchStrict = true;
          break;
        case (searchTerm.toLowerCase().startsWith('plz:') && searchTerm.length > 4):
          this.queryProperty = 'zip';
          this.searchTerm = searchTerm.replace('plz:', '');
          this.searchStrict = true;
          break;
        default:
          this.queryProperty = 'company';
          this.searchTerm = searchTerm;
          this.searchStrict = false;
      }
    }else {
      this.queryProperty = 'company';
      this.searchTerm = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/exists-audit-customer/exists-audit-customer.ts